<template>
  <div
    class="card-body border rounded"
    :class="theme == 'light' ? 'bg-white' : 'border-info'"
  >
    <div class="row mb-3">
      <div class="col-9">
        <h5 class="card-title mb-2">
          {{ $t("dashboards.performance-sandbox") }} <br /><span
            class="text-info"
            v-if="sandbox == 'ahn_lab'"
            >AHN LAB</span
          ><span class="text-info" v-else-if="sandbox == 'checkpoint'"
            >Checkpoint</span
          ><span class="text-info" v-else>ALL</span>
        </h5>
      </div>
      <div class="col-3">
        <!-- <select
                class="form-control"
                id="exampleFormControlSelect1"
                v-model="sandbox"
                disabled
              >
                <option value="all">All</option>
                <option value="ahn_lab">AhnLab</option>
                <option value="checkpoint">Checkpoint</option>
                <option value="1y">1 {{ $t("dashboards.year") }}</option>
              </select> -->
      </div>
    </div>
    <div class="row" v-if="sandbox == 'all' || sandbox == 'ahn_lab'">
      <div class="col-sm-8">
        <h5 v-if="sandbox == 'all'">Ahn Lab</h5>
        <small style="display: none">{{ series1 }}</small>
        <!-- <apexchart
          class="apex-charts"
          height="350"
          ref="chart"
          type="area"
          dir="ltr"
          :series="series1"
          :options="{
            chart: {
              id: 'realtime',
              type: 'area',
              toolbar: {
                show: false,
              },
              animations: {
                enabled: false,
                easing: 'linear',
                dynamicAnimation: {
                  speed: 2000,
                },
              },
            },

            dataLabels: {
              enabled: false,
            },
            stroke: {
              curve: 'straight',
              width: [1, 0, 0],
            },
            colors: ['#0369a1'],
            xaxis: {
              type: 'text',
              categories: [
                '60 Seconds',
                '',
                '',
                '',
                '',
                '',
                '',
                '',
                '',
                '',
                '',
                '',
                '',
                '',
              ],
            },
            grid: {
              show: true,
              strokeDashArray: 0.3,
              borderColor: '#000', // you can either change hear to disable all grids
              xaxis: {
                lines: {
                  show: false, //or just here to disable only x axis grids
                },
              },
              yaxis: {
                lines: {
                  show: true, //or just here to disable only y axis
                },
              },
            },
          }"
        ></apexchart> -->

        <div class="row">
          <!-- <div class="col-3 px-4">
                  <div>
                    <span> Utilitization </span> 
                    <h4>{{data_cpu.utilitization}}%</h4>
                  </div>
                  <div>
                    <span> Proceses </span> 
                    <h4>{{data_cpu.proceses}}</h4>
                  </div>
                  <div>
                    <span> Up time </span> 
                    <h4>{{data_cpu.up_time}}</h4>
                  </div>
              </div>
              <div class="col-3">
                  <div>
                      <span> Speed </span> 
                      <h4>{{data_cpu.speed}} GHz</h4>
                  </div>
                  <div>
                      <span> Threads </span> 
                      <h4>{{data_cpu.threads}}</h4>
                  </div>
                  <div>
                      <span> Handles </span> 
                      <h4>{{data_cpu.handles}}</h4>
                  </div>
              </div> -->
          <!-- <div class="col-6">
                  <span>Base speed: <b> {{data_cpu.base_speed}} Ghz </b></span> <br>
                  <span>Sockets: <b> {{data_cpu.sockets}} </b></span> <br>
                  <span>Cores: <b> {{data_cpu.cores}} </b></span> <br>
                  <span>Logical: <b> {{data_cpu.logical}} </b></span> <br>
                  <span>Virtualization: <b> {{data_cpu.virtualization}} </b></span> <br>
                  <span>L1 Cache: <b> {{data_cpu.l1_chace}} Kb </b></span> <br>
              </div> -->
          <div class="col-6">
            <div class="ml-3">
              <h6>System Status</h6>
              <span
                >Hostname: <b> {{ ahn_status.hostname }} </b></span
              >
              <br />
              <span
                >Machine: <b> {{ ahn_status.machine }} </b></span
              >
              <br />
              <span
                >Device ID: <b> {{ ahn_status.device_id }} </b></span
              >
              <br />
              <span
                >Version: <b> {{ ahn_status.version }} </b></span
              >
              <br />
              <span
                >Max Size: <b> {{ ahn_status.max_size }} </b></span
              >
              <br />
              <span
                >VM Runtime: <b> {{ ahn_status.vm_runtime }} </b></span
              >
              <br />
              <span
                >Asde Version: <b> {{ ahn_status.asde_version }} </b></span
              >
              <br />
              <span
                >Heimdall Use: <b> {{ ahn_status.heimdall_use }} </b></span
              >
              <br />
              <span
                >Facon Use: <b> {{ ahn_status.facon_use }} </b></span
              >
              <br />
              <span
                >Closed Network: <b> {{ ahn_status.closed_network }} </b></span
              >
              <br />
            </div>
          </div>
          <div class="col-6">
            <h6>System VM</h6>
            <span
              >Requested Files: <b> {{ ahn_vm.requested_files }} </b></span
            >
            <br />
            <span
              >VM Total: <b> {{ ahn_vm.vm_total }} </b></span
            >
            <br />
            <span
              >VM Running: <b> {{ ahn_vm.vm_running }} </b></span
            >
            <br />
            <span
              >VM Idle: <b> {{ ahn_vm.vm_idle }} </b></span
            >
            <br />
            <span
              >VM Valid: <b> {{ ahn_vm.vm_valid }} </b></span
            >
            <br />
            <span
              >Vm Queue: <b> {{ ahn_vm.vm_queue }} </b></span
            >
            <br />
          </div>
        </div>
      </div>
      <div class="col-sm-4">
        <!-- <apexchart
          class="apex-charts"
          height="380"
          type="donut"
          dir="ltr"
          :series="diskSpace.series"
          :options="diskSpace.chartOptions"
        ></apexchart> -->
      </div>
    </div>
    <hr />
    <!-- <div class="row" v-if="sandbox == 'all' || sandbox == 'checkpoint'">
        <div class="col-sm-8">    
        <small style="display:none;" >{{series2}}</small>
        <h5 v-if="sandbox == 'all'">Checkpoint</h5>
           <apexchart
                class="apex-charts"
                height="350"
                type="area"
                dir="ltr"
                :series="series2"
                :options="{
                    chart: {
                        id: 'realtime',
                        type: 'area',
                        toolbar: {
                        show: false
                        },
                        animations: {
                            enabled: false,
                            easing: 'linear',
                            dynamicAnimation: {
                            speed: 2000
                            }
                        },
                    },
                    
                    dataLabels: {
                        enabled: false
                    },
                    stroke: {
                      curve: 'straight',
                       width: [1,0,0],
                    },
                    colors: ['#0369a1'],
                    xaxis: {
                        type: 'text',
                        categories: ['60 Seconds', '', '', '', '', '', '', '', '', '', '', '', '',''],
                    },
                    grid: {  
                        show: true,
                        strokeDashArray: 0.3,
                        borderColor: '#000',    // you can either change hear to disable all grids
                        xaxis: {
                            lines: {
                            show: false  //or just here to disable only x axis grids
                            }
                            },  
                        yaxis: {
                            lines: { 
                            show: true  //or just here to disable only y axis
                            }
                        }, 
                    }
                }"
            ></apexchart>

            <div class="row">
              <div class="col-3 px-4">
                  <div>
                    
                    <span> Utilitization </span> 
                    <h4>{{data_cpu2.utilitization}} %</h4>
                  </div>
                  <div>
                    <span> Proceses </span> 
                    <h4>{{data_cpu2.proceses}}</h4>
                  </div>
                  <div>
                    <span> Up time </span> 
                    <h4>{{data_cpu2.up_time}}</h4>
                  </div>
              </div>
              <div class="col-3">
                  <div>
                      <span> Speed </span> 
                      <h4>{{data_cpu2.speed}} GHz</h4>
                  </div>
                  <div>
                      <span> Threads </span> 
                      <h4>{{data_cpu2.threads}}</h4>
                  </div>
                  <div>
                      <span> Handles </span> 
                      <h4>{{data_cpu2.handles}}</h4>
                  </div>
              </div>
  
              <div class="col-6">
                  <span>Base speed: <b> {{data_cpu2.handles}} Ghz </b></span> <br>
                  <span>Sockets: <b> {{data_cpu2.handles}} </b></span> <br>
                  <span>Cores: <b> {{data_cpu2.cores}} </b></span> <br>
                  <span>Logical: <b> {{data_cpu2.logical}} </b></span> <br>
                  <span>Virtualization: <b> {{data_cpu2.virtualization}} </b></span> <br>
                  <span>L1 Cache: <b> {{data_cpu2.l1_chace}} Kb </b></span> <br>
              </div>
            </div>
        </div>
        <div class="col-sm-4">
            <apexchart
                class="apex-charts"
                height="380"
                type="donut"
                dir="ltr"
                :series="diskSpace2.series"
                :options="diskSpace2.chartOptions"
            ></apexchart>
        </div>
    </div> -->
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import MalwareServices from "@/helpers/malware.service";
import moment from "moment";
/**
 * Email-sent component
 */
export default {
  props: ["sandbox"],

  data() {
    const diskSpace = {
      series: [80, 20],
      chartOptions: {
        labels: ["  Used <b>8 GB</b> ", " Free Space<b> 2 GB</b>"],
        colors: ["#34c38f", "#6b7280"],
        legend: {
          show: true,
          position: "bottom",
          horizontalAlign: "center",
          verticalAlign: "middle",
          floating: false,
          fontSize: "14px",
          offsetX: 0,
          offsetY: 10,
        },
        responsive: [
          {
            breakpoint: 600,
            options: {
              chart: {
                height: 240,
              },
              legend: {
                show: false,
              },
            },
          },
        ],
      },
    };

    const diskSpace2 = {
      series: [50, 50],
      chartOptions: {
        labels: ["  Used <b>12 GB</b> ", " Free Space<b> 6 GB</b>"],
        colors: ["#34c38f", "#6b7280"],
        legend: {
          show: true,
          position: "bottom",
          horizontalAlign: "center",
          verticalAlign: "middle",
          floating: false,
          fontSize: "14px",
          offsetX: 0,
          offsetY: 10,
        },
        responsive: [
          {
            breakpoint: 600,
            options: {
              chart: {
                height: 240,
              },
              legend: {
                show: false,
              },
            },
          },
        ],
      },
    };

    return {
      theme: localStorage.getItem("theme"),
      select_sandbox: this.sandbox,
      diskSpace,
      diskSpace2,
      loading_ahn: false,
      ahn_status: {
        hostname: "MDS",
        machine: "MDS10000",
        device_id: "227e4c",
        version: "2.1.20.15(Build 454)",
        max_size: 314572800,
        vm_runtime: 300,
        asde_version: 1,
        heimdall_use: 1,
        facon_use: 1,
        closed_network: 0,
      },
      ahn_vm: {
        requested_files: 0,
        vm_total: 128,
        vm_running: 0,
        vm_idle: 128,
        vm_valid: 128,
        vm_queue: 0,
      },
      data_cpu: {
        utilitization: 19,
        proceses: 233,
        up_time: "3:20:22:10",
        speed: "2,55",
        threads: 24326,
        handles: 90245,
        base_speed: "2,11",
        sockets: "1",
        cores: "4",
        logical: "8",
        virtualization: "Enabled",
        l1_chace: "256",
      },
      data_cpu2: {
        utilitization: 31,
        proceses: 133,
        up_time: "2:30:41:14",
        speed: "3,55",
        threads: 14326,
        handles: 70245,
        base_speed: "3,11",
        sockets: "2",
        cores: "4",
        logical: "8",
        virtualization: "Enabled",
        l1_chace: "206",
      },
      series1: [
        {
          data: [50, 10, 34, 22, 40, 20, 50, 30, 45, 71, 60, 10, 50, 20],
        },
      ],
      series2: [
        {
          data: [40, 50, 14, 12, 50, 40, 80, 20, 75, 40, 20, 10, 70, 20],
        },
      ],
    };
  },
  methods: {
    setCpuUsage() {
      setInterval(() => {
        // console.log('set inet');
        // this.data_cpu.up_time = this.data_cpu.up_time+1;
        const util = Math.floor(50 + Math.random() * 15);
        const proce = Math.floor(200 + Math.random() * 20);
        const threads = Math.floor(2000 + Math.random() * 300);
        const handles = Math.floor(90091 + Math.random() * 100);
        const speed = Math.floor(10 + Math.random() * 10);
        const util2 = Math.floor(50 + Math.random() * 15);
        const proce2 = Math.floor(200 + Math.random() * 20);
        const threads2 = Math.floor(2000 + Math.random() * 300);
        const handles2 = Math.floor(90091 + Math.random() * 100);
        const speed2 = Math.floor(10 + Math.random() * 10);

        this.data_cpu.utilitization = util;
        this.data_cpu.speed = this.data_cpu.speed[0] + "," + speed;
        this.data_cpu.threads = threads;
        this.data_cpu.handles = handles;
        this.data_cpu.proceses = proce;

        this.data_cpu2.utilitization = util2;
        this.data_cpu2.speed = this.data_cpu.speed[0] + "," + speed2;
        this.data_cpu2.threads = threads2;
        this.data_cpu2.handles = handles2;
        this.data_cpu2.proceses = proce2;

        let now = moment();
        const times = now.format("hh:mm:ss");
        this.data_cpu.up_time = this.data_cpu.up_time[0] + ":" + times;
        this.data_cpu2.up_time = this.data_cpu2.up_time[0] + ":" + times;

        let idx = 0;
        const a = this.series1[0].data[idx + 1];
        const b = this.series1[0].data[idx + 2];
        const c = this.series1[0].data[idx + 3];
        const d = this.series1[0].data[idx + 4];
        const e = this.series1[0].data[idx + 5];
        const f = this.series1[0].data[idx + 6];
        const g = this.series1[0].data[idx + 7];
        const h = this.series1[0].data[idx + 8];
        const i = this.series1[0].data[idx + 9];
        const j = this.series1[0].data[idx + 10];
        const k = this.series1[0].data[idx + 11];
        const l = this.series1[0].data[idx + 12];
        const m = this.series1[0].data[idx + 13];
        const n = Math.floor(Math.random() * 100);

        const a2 = this.series2[0].data[idx + 1];
        const b2 = this.series2[0].data[idx + 2];
        const c2 = this.series2[0].data[idx + 3];
        const d2 = this.series2[0].data[idx + 4];
        const e2 = this.series2[0].data[idx + 5];
        const f2 = this.series2[0].data[idx + 6];
        const g2 = this.series2[0].data[idx + 7];
        const h2 = this.series2[0].data[idx + 8];
        const i2 = this.series2[0].data[idx + 9];
        const j2 = this.series2[0].data[idx + 10];
        const k2 = this.series2[0].data[idx + 11];
        const l2 = this.series2[0].data[idx + 12];
        const m2 = this.series2[0].data[idx + 13];
        const n2 = Math.floor(Math.random() * 100);

        this.series1[0].data = [a, b, c, d, e, f, g, h, i, j, k, l, m, n];
        this.series2[0].data = [
          a2,
          b2,
          c2,
          d2,
          e2,
          f2,
          g2,
          h2,
          i2,
          j2,
          k2,
          l2,
          m2,
          n2,
        ];
        // console.log('series1', this.series1[0].data[0]);

        // this.$refs.chart.setCpuUsage([
        //   a, b, c, d, e, f, 90, 23, 50, 82,12, 16, a, d
        // ], false, true)
        // this.series1[0].data.shift();
        // this.series1[0].data.push(a);
      }, 1000);
    },

    sysStatus() {
      let ferr = 0;
      this.loading_ahn = true;
      MalwareServices.systemStatus()
        .then((response) => {
          // console.log('res', response);
          if (response.status == 201) {
            let new_token = response.data.refresh_access_token;
            userService.splitToken(new_token);
            this.sysStatus();
            ferr = 1;
            this.$store.dispatch("notification/refreshtoken", "refresh");
          } else {
            ferr = 2;
            let res = response.data.data;
            this.ahn_status.hostname = res.hostname;
            this.ahn_status.machine = res.machine;
            this.ahn_status.device_id = res.device_id;
            this.ahn_status.max_size = res.max_size;
            this.ahn_status.vm_runtime = res.vm_runtime;
            this.ahn_status.asde_version = res.asde_version;
            this.ahn_status.heimdall_use = res.heimdall_use;
            this.ahn_status.facon_use = res.facon_use;
            this.ahn_status.closed_network = res.closed_network;
            // console.log('res ahn', res);
            this.loading_ahn = false;
          }
        })
        .catch((err) => {
          console.log("err ->> ", err);
          this.loading_ahn = false;
          if (err.response == undefined) {
            console.log("err ->> ", err);
          } else if (
            this.$store.state.notification.type === "refresh-token" &&
            err.response.status == 401
          ) {
            this.sysStatus();
          } else {
            if (err.response.status == 401) {
              userService.logout();
            } else {
              console.log(err);
            }
            // this.loading = false;
          }
        });
    },

    sysVM() {
      let ferr = 0;
      this.loading_ahn = true;
      MalwareServices.systemVM()
        .then((response) => {
          // console.log('res', response);
          if (response.status == 201) {
            let new_token = response.data.refresh_access_token;
            userService.splitToken(new_token);
            this.sysVM();
            ferr = 1;
            this.$store.dispatch("notification/refreshtoken", "refresh");
          } else {
            ferr = 2;
            let res = response.data.data;
            this.ahn_vm.requested_files = res.requested_files;
            this.ahn_vm.vm_idle = res.vm_idle;
            this.ahn_vm.vm_queue = res.vm_queue;
            this.ahn_vm.vm_running = res.vm_running;
            this.ahn_vm.vm_runtime = res.vm_runtime;
            this.ahn_vm.vm_total = res.vm_total;
            this.ahn_vm.vm_valid = res.vm_valid;

            // console.log('res ahn vm', res);
            this.loading_ahn = false;
          }
        })
        .catch((err) => {
          console.log("err ->> ", err);
          this.loading_ahn = false;
          if (err.response == undefined) {
            console.log("err ->> ", err);
          } else if (
            this.$store.state.notification.type === "refresh-token" &&
            err.response.status == 401
          ) {
            this.sysVM();
          } else {
            if (err.response.status == 401) {
              userService.logout();
            } else {
              console.log(err);
            }
            // this.loading = false;
          }
        });
    },
  },
  mounted() {
    this.setCpuUsage();
    this.sysStatus();
    this.sysVM();
  },
};
</script>
